import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';

function News() {
  return <ArticlesList subtype="News" type="Cruises" />;
}

export default withLayout(News, true);
